





















































import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, Action, Mutation, State } from "vuex-class";
import SnapshotItem from "./SnapshotItem.vue";
import ExternalItem from "./ExternalItem.vue";

@Component({
  components: {
    SnapshotItem,
    ExternalItem
  }
})
class Snapshots extends Vue {
  @Prop() assetId;

  @Prop() asset;

  @State(state => state.wallet.mixin.snapshots.hasNext) hasNext;

  @State(state => state.wallet.mixin.snapshots.assetId) snapshotAssetId;

  @Getter("wallet/mixin/snapshots/getGroupedSnapshots") snapshotsGroup;

  @Mutation("wallet/mixin/snapshots/REMOVE_SNAPSHOTS") removeSnapshots;

  @Mutation("wallet/mixin/snapshots/REMOVE_EXTERNALS") removeExternals;

  @Mutation("wallet/mixin/snapshots/SET_ASSET_ID") setSnapshotAssetId;

  @Action("wallet/mixin/snapshots/loadSnapshots") loadSnapshots;

  @Action("wallet/mixin/snapshots/loadExternals") loadExternals;

  loading = false;

  forbidden = false;

  error = false;

  get loadMoreDisabled() {
    return this.loading || !this.hasNext;
  }

  mounted() {
    if (this.assetId !== this.snapshotAssetId) {
      this.removeSnapshots();
      this.removeExternals();
    }
    this.setSnapshotAssetId(this.assetId);
  }

  refresh() {
    this.removeSnapshots();
    this.removeExternals();
    this.loadMore();
  }

  isToday(item) {
    return this.$common.utils.date.isToday(item);
  }

  async loadMore() {
    if (this.forbidden || this.error) {
      return;
    }
    this.loading = true;
    await this.requestLoadSnapshots();
    await this.requestLoadExternals();
    this.loading = false;
  }

  async requestLoadSnapshots() {
    try {
      await this.loadSnapshots(this.assetId);
    } catch (error) {
      if (error.status === 403) {
        this.forbidden = true;
        this.$root.$emit(this.$rootEvents.ASSETS_FORBIDDEN, "SNAPSHOTS");
        return;
      }
      this.$common.utils.helper.errorHandler(this, error);
    }
  }

  async requestLoadExternals() {
    try {
      const params = {
        destination: this.asset.destination,
        asset_id: this.asset.asset_id,
        tag: this.asset.tag
      };
      await this.loadExternals(params);
    } catch (error) {
      this.error = true;
      this.$common.utils.helper.errorHandler(this, error);
    }
  }
}
export default Snapshots;
